<template>
	<div class="content">
		<div class="header">
			<div class="top_header clearfix">
				<div class="logo fl_left"> 
					<div class="logo_img fl_left"></div>
					<div class="fl_left" style="font-size:20px;letter-spacing: 2px;line-height:70px;font-weight:bold;color:#333;"><span style="margin:0 15px;">·</span>后台管理系统</div>
				</div>
	    		<!-- <ul class="nav_wrap fl_left">
		    		<router-link tag="li" to="/addCategory/centersCon" active-class="active" >首页</router-link>
		    		<router-link tag="li" to="/material" active-class="active" >素材管理</router-link>
		    		<router-link tag="li" to="/users" active-class="active" >用户管理</router-link>
		    		<router-link tag="li" to="/diction" active-class="active" >权限管理</router-link>
	    		</ul> -->
	    		<div class="fl_right user" @mouseenter="enter" @mouseleave="leave">
	    		    <div class="userName fl_left">{{account}}</div>
	    		    <div class="siginUp siginUps" v-show="show">
	    		        <div class="oneSign" @click="revisePass" style="border:0;">修改密码</div>
	    		        <div class="oneSign" @click="setPhone">修改登录手机号</div>
	    		        <div class="oneSign" @click="siginUp">退出</div>
	    		    </div>
	    		</div>
	    		<div class="message fl_right" @mouseenter="enter1" @mouseleave="leave1">
	    			<!-- <Badge :count="wdu">
	    				    		        <Icon type="ios-notifications-outline" size="26"></Icon>
	    				    		    </Badge>  -->
	    		    <!-- <el-badge :value="wdu" class="item" style="font-size:180%">
	    		    	<i class="el-icon-bell"></i>
	    		    </el-badge>  -->
	    		    <div class="siginUps siginUp1" v-show="show1" style="border-radius: 10px;">
	    		        <div class="" style="font-size: 17px;color:#666;line-height: 50px;overflow: hidden;">消息列表<span title="全部标记为已读" class="fl_right yduClick" @click="yuclick"></span></div>
	    		        <div class="oneSign" style="text-align:center;" v-if="wdu===0">暂无消息</div>
	    		        <div class="oneSign yoneSign" v-else v-for="(item,index) in yulist" :class="{'yoneSigns':item.read==1}">
	    		            <div class="fl_left" style="width: 260px;white-space:normal;">{{item.content}}</div>
	    		            <div class="fl_right">{{item.date}}</div>
	    		            <div class="clear"></div>
	    		        </div>
	    		    </div>      
	    		</div>
	    		<div class="messages fl_right" @mouseenter="enter2" @mouseleave="leave2"><!-- @click="qd_url"  @mouseenter="enter2" @mouseleave="leave2" -->
	    		    <div class="ercode">APP下载</div>   
	    		    <div class="siginUps siginUp2" v-show="show2">
	    		        <div id="printpage">
	    		            <div class="divup">
	    		            </div>
	    		            <div style="text-align: center;margin-bottom: 10px;text-indent:0">APP下载二维码</div>
	    		        </div>
	    		        <!-- <div class="addClass" id="addClass">打印</div> -->
	    		    </div>    
	    		</div>
		    	<!-- <div class="fl_right">
		    		<el-popover placement="bottom" trigger="hover">
				    	<div slot="reference" class="portrait"></div>
				    	<div @click="logout" class="cur_po">退出登录</div>
				  	</el-popover>
		    	</div> -->
			</div>
	    </div>
	    <div class="center">
            <div class="itemBox fl_left">
                <div v-for="(item,index) in items" @click="tab">
                    <div class="div itemssloat itemList grayTitle" v-if="item.index===0">
                    	<div class="iconfont fl_left" :class="{'iconshuju':item.type==0,'iconchengbandanwei':item.type==1,'iconpeixunzhongxin':item.type==2,'iconyonghu':item.type==3,'iconkejian':item.type==4,'iconzhanghao':item.type==5,'iconicon_huabanfuben':item.type==6,'iconpeizhi':item.type==7,}"></div>
                    	<div>{{item.title}}</div>   
                    </div>
                    <div class="div itemssloat itemList" v-else style="padding-left: 0;">
                    	<router-link class="itemList" active-class="itemLists" :to="{path:item.path}">
                    		<div class="iconfont fl_left" :class="{'iconshuju':item.type==0,'iconchengbandanwei':item.type==1,'iconpeixunzhongxin':item.type==2,'iconyonghu':item.type==3,'iconkejian':item.type==4}"></div>
                    		<div>{{item.title}}</div>
                        </router-link>
                    </div>
                    <div style="border-bottom: 1px solid #ebeae8;">
                        <div class="erList" v-for="(num,index) in item.erList" @click.stop="tab(num.num)">
                            <router-link class="itemList" active-class="itemLists" :to="{path:num.path}">
                                <div class="iconfont icon-shouye fl_left" style="margin-right: 4px;width:32px;font-size:0;"></div>
                                {{num.title}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fl_right wlBox">
                <router-view></router-view>
            </div>
        </div>
	    <div>
	    	<!-- <router-view></router-view> -->
	    	<BackTop :height="300" :bottom="60" :right="10"></BackTop>
	    </div>
	    <div class="alertBox" v-show="alertShow">
	        <div class="alert">
	            <div class="list listpad" v-show="walm==0">
	                <div class="fl_left name">手机号</div>
	                <div class="fl_left inputBox">
	                    <Input v-model="account" class="borDiv" disabled></Input>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <div class="list listpad" v-show="walm==0">
	                <div class="fl_left name">验证码</div>
	                <div class="fl_left inputBox" style="position: relative;width:380px;">
	                    <Input v-model="smscoded" class="borDiv" placeholder="请输入验证码" style="width:270px;"></Input>
	                    <button @click="handCoded" class="codeBtn" :disabled="!codeShowd">
	                       <span v-show="codeShowd">获取验证码</span>
	                       <span v-show="!codeShowd" class="count">{{countsd}} s</span>
	                    </button>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <div class="list listpad" v-show="walm==0">
	                <div class="fl_left name">新密码</div>
	                <div class="fl_left inputBox">
	                    <Input v-model="value1" class="borDiv" placeholder="请输入新密码" type="password"></Input>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <div class="list listpad" v-show="walm==0">
	                <div class="fl_left name">请确定新密码</div>
	                <div class="fl_left inputBox">
	                    <Input v-model="value3" class="borDiv" placeholder="请再次输入新密码" type="password"></Input>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <div class="list listpad" v-show="walm==1">
	                <div class="fl_left name">新的登录手机号</div>
	                <div class="fl_left inputBox">
	                    <Input v-model="phone" class="borDiv" placeholder="请输入新的登录手机号"></Input>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <div class="list listpad" v-show="walm==1">
	                <div class="fl_left name">验证码</div>
	                <div class="fl_left inputBox" style="position: relative;width:380px;">
	                    <Input v-model="smscode" class="borDiv" placeholder="请输入验证码" style="width:270px;"></Input>
	                    <button @click="handCode" class="codeBtn" :disabled="!codeShow">
	                       <span v-show="codeShow">获取验证码</span>
	                       <span v-show="!codeShow" class="count">{{counts}} s</span>
	                    </button>
	                </div>
	                <div class="clear"></div>
	            </div>
	            <!-- <div class="list listpad" v-show="walm==1">
	                <div class="fl_left name">密码</div>
	                <div class="fl_left inputBox">
	                    <Input v-model="phopass" class="borDiv" type="password" placeholder="请输入密码"></Input>
	                </div>
	                <div class="clear"></div>
	            </div> -->
	            <div class="list alerTopBor">
	                <div class="fl_left alertBtn alerBoder" @click="noAlert">取消</div>
	                <div class="fl_right alertBtn" @click="yesAlert(walm)">确定</div>
	                <div class="clear"></div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				items:[
                        /*{
                            title:'数据中心',
                            index:1,
                            path:'/manager/data/dataCount',
                            type:0,
                        },*/
                        {
                            title:'承办单位管理',
                            index:1,
                            path:'/manager/company/company',
                            type:1,
                        },
                        {
                            title:'师资培训管理',
                            index:0,
                            erList:[
                                {
                                    title:'培训期次',
                                    path:'/manager/teacher/class',
                                },
                                {
                                    title:'作业管理',
                                    path:'/manager/teacher/work',
                                },
                                {
                                    title:'退班管理',
                                    path:'/manager/teacher/tui',
                                },
                            ],
                            type:2,
                        },
                        {
                            title:'教演结合管理',
                            index:0,
                            erList:[
                                {
                                    title:'教演结合',
                                    path:'/perform/index',
                                },
                            ],
                            type:2,
                        },
                        {
                            title:'学生考级管理',
                            index:0,
                            erList:[
                                {
                                    title:'考级报名',
                                    path:'/stuexam/index',
                                },
                            ],
                            type:2,
                        },
                        {
                            title:'展演管理',
                            index:0,
                            erList:[
                                {
                                    title:'展演管理',
                                    path:'/performance/index',
                                },
                            ],
                            type:2,
                        },
                        {
                            title:'用户管理',
                            index:0,
                            erList:[
                                {
                                    title:'高教管理',
                                    path:'/manager/user_mager/tea',
                                },
                                {
                                    title:'学员管理',
                                    path:'/manager/user_mager/stu',
                                },
                                {
                                    title:'证书管理',
                                    path:'/manager/user_mager/zs',
                                },
                            ],
                            type:3,
                        },
                        {
                            title:'课件管理',
                            index:0,
                            erList:[
                                {
                                    title:'课件制作',
                                    path:'/manager/stu_class/class/singleLesson',
                                },
                            ],
                            type:4,
                        },
                        {
                            title:'财务管理',
                            index:0,
                            erList:[
                                {
                                    title:'订单管理',
                                    path:'/manager/finance/order',
                                },
                                {
                                    title:'分成结算',
                                    path:'/manager/finance/finance',
                                },
								{
                                    title:'记账系统',
                                    path:'/manager/finance/accounts',
                                },
                            ],
                            type:6,
                        },
                        {
                            title:'系统配置',
                            index:0,
                            erList:[
                                {
                                    title:'首页推荐',
                                    path:'/manager/peizhi/index',
                                },
                                {
                                    title:'通知管理',
                                    path:'/manager/peizhi/newsList',
                                },
                                {
                                    title:'日志管理',
                                    path:'/manager/peizhi/rizhi',
                                },
                                {
                                    title:'更新日志',
                                    path:'/manager/peizhi/updateLog',
                                },
                            ],
                            type:7,
                        },
                        {
                            title:'账号管理',
                            index:0,
                            erList:[
                                {
                                    title:'账号设置',
                                    path:'/manager/admin/admin',
                                },
                            ],
                            type:5,
                        },
                    ],
                wdu:2,
                show2:false,
                show1:false,
                show1s:false,
                show:false,
                alertShow:false,
                yulist:[],
                account:1800000000,
                walm:'',
                smscode:'',
                counts:'',
                phone:'',
                value3:'',
                value1:'',
                countsd:'',
                smscoded:'',
                codeShow:true,
                codeShowd:true,
			}
		},
		methods:{
			tab(){
				localStorage.removeItem('luder');
			},
			logout(){
				let _this = this;
				localStorage.clear()
				sessionStorage.clear()
				_this.$router.push({path:"/login"})
			},
			enter(e){
			    e.stopPropagation();
			    this.show = true;
			},
			leave(e){
			    e.stopPropagation();
			    this.show = false;
			},
			enter1(e){
			    e.stopPropagation();
			    this.show1 = true;
			},
			enter2(e){
			    e.stopPropagation();
			    this.show2 = true;
			},
			leave2(e){
			    e.stopPropagation();
			    this.show2 = false;
			},
			leave1(e){
			    e.stopPropagation();
			    this.show1 = false;
			},
			yuclick(index,val){
			    let _this=this;
			    _this.$axios.post('changemessagestatus',{}).then(res=>{
			        if(res.data.code==200){
			            _this.getList();
			         }
			         else{
			             this.$Message.error(res.data.message);
			         }
			    }).catch(function (error) {
			      console.log(error);
			    });
			},
			getList(){
			    let _this=this;
			    _this.$axios.post('getmessagelist',{}).then(res=>{
			        if(res.data.code==200){
			            if(res.data.data.length==0){
			                _this.show1s=true;
			            }
			            else{
			                _this.show1s=false;
			                this.yulist=res.data.data;
			            }
			        }
			        else{
			             this.$Message.error(res.data.message);
			        }
			    }).catch(function (error) {
			      console.log(error);
			    });
			    _this.$axios.post('getmessagestatus',{}).then(res=>{
			        if(res.data.code==200){
			            if(res.data.data>0){
			                _this.wdu=res.data.data;
			            }
			            else{
			                _this.wdu=0;
			            }
			        }
			        else{
			             this.$Message.error(res.data.message);
			        }
			    }).catch(function (error) {
			      console.log(error);
			    });
			},
			siginUp(){
			    let _this=this;
			    _this.$axios.post('logout',{}).then(res=>{
			        if(res.data.code==200){
			            this.$router.push({
			                path:'/login'
			            })
			        }
			        else{
			            this.$Message.error(res.data.message);
			        }
			    }).catch(function (error) {
			      console.log(error);
			    });
			},
			setPhone(){
			    let _this=this;
			    _this.walm=1;
			    _this.alertShow=true;
			},
			revisePass(){
			    this.walm=0;
			    this.alertShow=true;
			},
			handCoded(){
			    let _this=this;
			    _this.$axios.post('getsmscode',{phone:_this.account}).then(res=>{
			        if(res.data.code==200){
			        	_this.smskey=res.data.data.smskey;
			            if (!_this.timer) {
			                _this.countsd = 60;
			                _this.codeShowd = false;
			                _this.timer = setInterval(() => {
			                  if (_this.countsd > 0 && _this.countsd <= 60) {
			                    _this.countsd--;
			                  } else {
			                    _this.codeShowd = true;
			                    clearInterval(_this.timer);
			                    _this.timer = null;
			                  }
			                }, 1000)
			            }
			        }
			        else{
			            this.$Message.error(res.data.message)
			        }
			    }).catch( function(response) {
			        console.log(response)
			    });
			},
			handCode(){
			    let _this=this;
			    let pattern=/^1[3456789]\d{9}$/;//手机号验证
			    if(_this.phone==''){
			        this.$Message.error('请输入手机号');
			    }
			    else if(pattern.test(_this.phone)==false){
			        this.$Message.error('手机号输错了');
			    }
			    else{
			        _this.$axios.post('getsmscode',{phone:_this.phone}).then(res=>{
			            if(res.data.code==200){
			            	_this.smskey=res.data.data.smskey;
			                if (!_this.timer) {
			                    _this.counts = 60;
			                    _this.codeShow = false;
			                    _this.timer = setInterval(() => {
			                      if (_this.counts > 0 && _this.counts <= 60) {
			                        _this.counts--;
			                      } else {
			                        _this.codeShow = true;
			                        clearInterval(_this.timer);
			                        _this.timer = null;
			                      }
			                    }, 1000)
			                }
			            }
			            else{
			                this.$Message.error(res.data.message)
			            }
			        }).catch( function(response) {
			            console.log(response)
			        });
			    }
			},
			noAlert(){
			    this.alertShow=false;
			},
			yesAlert(index){
			    if(index==0){
			        let _this=this;
			        let checkPass = /^[0-9a-zA-Z]{6,20}$/;//密码
			        if(_this.smscoded==''){
			            this.$Message.error('请输入验证码');
			        }
			        else if(_this.value1==''){
			            this.$Message.error('请输入新密码');
			        }
			        else if(_this.value1!=_this.value3){
			            this.$Message.error('密码不一致');
			        }
			        else{
			            _this.$axios.post('changepassword',{
			                // oldpassword:_this.value,
			                new_pwd:_this.value1,
			                smscode:_this.smscoded,
			                phone:_this.account,
			                smskey:_this.smskey,
			            }).then(res=>{
			                if(res.data.code==200){
			                     this.alertShow=false;
			                     this.$router.push({
			                         path:'/login'
			                     })
			                 }
			                 else{
			                     this.$Message.error(res.data.message);
			                 }
			            }).catch(function (error) {
			              console.log(error);
			            });
			        }
			    }
			    else{
			        let _this=this;
			        let pattern=/^1[3456789]\d{9}$/;//手机号验证
			        if(_this.phone==''){
			            this.$Message.error('请输入新的登录手机号');
			        }
			        else if(pattern.test(_this.phone)==false){
			            this.$Message.error('新的登录手机号输错了');
			        }
			        // else if(_this.phopass==''){
			        //     this.$Message.error('密码不能为空');
			        // }
			        else if(_this.smscode==''){
			            this.$Message.error('请输入验证码');
			        }
			        else{
			            _this.$axios.post('changephone',{
			                phone:_this.phone,
			                smscode:_this.smscode,
			                smskey:_this.smskey,
			                // password:_this.phopass
			            }).then(res=>{
			                if(res.data.code==200){
			                     this.alertShow=false;
			                     // this.$Message.sucess('手机号修改成功！');
			                     this.$router.push({
			                         path:'/login',
			                     })
			                 }
			                 else{
			                    this.$Message.error(res.data.message);
			                    this.$router.push({
			                         path:'/login',
			                     })
			                 }
			            }).catch(function (error) {
			              console.log(error);
			            });
			        }
			    }
			},
		},
		created(){
			this.account=localStorage.getItem('phone');
		}
	};
</script>
<style scoped>
.header{min-width: 1152px;width: 100%;height: 70px;background: #fff ;box-sizing: border-box;padding: 0 40px;box-shadow: 0 3px 7px 0 rgba(0,0,0,.1);}
/*.top_header{width: 1152px;margin: 0 auto;}*/
.logo_img{background: url(../../static/imgs/header/logo.png) center center/169px no-repeat;width: 169px;height: 70px;}
.nav_wrap li{float: left;font-size: 14px;line-height: 64px;color: rgb(153,153,153,1);margin: 0 52px;cursor: pointer;}
.nav_wrap li.active{font-weight: bold;color: #c30d23;}
.portrait{background: url(../../static/imgs/avatar.png) left center no-repeat;height: 64px;width: 30px;background-size: 30px;cursor: pointer;position: relative;}
.itemBox{
    min-height: 1020px;
    /*width: 13%;*/
    background: #fff url(../../static/imgs/header/leftbg.png) left top/200px no-repeat;
    padding-top: 20px;
    padding-bottom: 20px;
    /*height: 100%; */
    border-right:1px solid #ebeae8;
    border-top:1px solid #ebeae8;
    width: 200px; 
}
.divup{
	background: url('../../static/imgs/upCode.png') center center/150px no-repeat;
	height: 160px;
	width: 160px;
}
.itemList{
    line-height: 48px;
    color: #333;
    height: 48px;
    width: 200px;
    padding-left: 40px;
    box-sizing: border-box;
}
.itemList:hover{
    opacity: 0.9;
}
.itemLists{
    color: #fff;
    background-color: #c30d23;
}
.iconfont{
	margin-right: 15px;
	color: #999;
}
.itemLists>.iconfont{
	color: #fff;
}
.erList>.itemList{
	padding-left: 71px;
	box-sizing: border-box;
}
.wlBox{
	padding: 0 20px;
	box-sizing: border-box;
	width:calc(100% - 200px);
}
.grayTitle{
	color: #999;
	cursor: no-drop;
}
/*消息*/
.siginUps{
    position: absolute;
    text-indent: 18px;
    top: 50px;
    right: 30px;
    background-color: #fff;
    box-shadow: 0px 0px 15px 0px rgba(112, 112, 112, 0.19);
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    z-index: 999;
}
.siginUp1{
    width: 400px;
    right: -15px;
    text-align: left;
    text-indent: 23px;
}
.siginUp2{
	right: -10px;
}
.yduClick{
    display: block;
    width: 20px;
    height: 50px;
    background: url('../../static/imgs/ydu.png') center center/20px no-repeat;
    margin-right: 22px;
}
.oneSign{
    line-height: 40px;
    border-top: 1px solid #dedede;
    color: #333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 130px;
}
.yoneSign{
    text-indent: 0;
    padding:0 16px 0 26px;
    box-sizing: border-box;
    min-height: 40px;
    color: #999;
}
.yoneSigns{
    background: url('../../static/imgs/red.png') left 12px top 17px/6px no-repeat;
    color: #333;
}
.oneSign:hover{
    background-color: #f5f5f5;
}
.message{
    height: 60px;
    margin: 10px 10px 0 0;
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    padding-top: 7px;
    box-sizing: border-box;
}
.messages{
    position: relative;
}
.user{
    background: url('../../static/imgs/icon_sanjiaox.png') right center no-repeat;
    background-size: 8px;
    height: 60px;
}
.ercode{
    width: 90px;
    background: url('../../static/imgs/erweima.png') left center/20px no-repeat;
    background-size: 20px;
    height: 60px;
    cursor: pointer;
    line-height: 60px;
    text-indent: 30px;
    font-size: 14px;
    color: #222;
}
.userName{
    color: #222;
    text-indent: 32px;
    line-height: 60px;
    margin: 0 12px 0 20px;
    background: url('../../static/imgs/avatar.png') left center no-repeat;
    background-size: 26px;
    cursor: pointer;
}
.codeBtn{
    cursor:pointer;
    position: absolute;
    top: 2px;
    right: 0;
    width: 90px;
    height: 30px;
    background-color: #ffffff;
    border: solid 1px #dc4e5a;
    color: #dc4e5a;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
}
.borDiv{
	border: 1px solid #e7e7eb;
    border-radius: 4px;
    overflow: hidden;
    width: 381px;
}
.name{
    line-height: 30px;
    text-align: right;
    color: #333;
    margin-right: 14px;
    width: 110px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager.vue